// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import Router, { useRouter } from 'next/router';
import { useQuery } from '@tanstack/react-query';
import ManageTaskTemplate from '@/components/task-template/manage';
import * as Enums from '@/utils/enums';
import Fetch from '@/utils/Fetch';
import BillingService from '@/services/billing-service';
import Helper from '@/utils/helper';
import SubscriptionContext from '@/utils/subscription-context';
import SettingsMenu from '@/components/settings/menu';
import Breadcrumbs from '@/components/breadcrumbs';
import { createFileRoute } from '@tanstack/react-router'

const EditTaskTemplate = () => {

  const router = useRouter();
  const { id } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

  let currPath = '';
  if (Router.router) {
    currPath = Router.router.asPath;
  }

  const subscriptionContext = useContext(SubscriptionContext);
  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const getAccessStatus = async () => {
    const [subscriptionInfo, message] = await BillingService.getSubcriptionInfo(subscriptionContext);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  const { data: taskTemplateData } = useQuery(
    ['taskTemplate', id],
    () => Fetch.get({ url: `/TaskTemplate/${id}` }),
    { enabled: !!id }
  );
  const [taskTemplate, setTaskTemplate] = useState<any>(null);
  useEffect(() => {
    if (taskTemplateData && !taskTemplate) {
      setTaskTemplate(taskTemplateData);
    }
  }, [taskTemplateData]);

  useEffect(() => {
    getAccessStatus();
  }, []);
  
  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace,"/");
    }
  }, [accessStatus]);

  if (!taskTemplate) return null;

  return (
    <div className="settings-container">
      <div className="row">
        <SettingsMenu urlPath={currPath} />
        <div className="settings-card">
          <ManageTaskTemplate taskTemplate={taskTemplate} setTaskTemplate={setTaskTemplate} isNew={false} accessStatus={accessStatus} />
        </div>
      </div>

      <style jsx>{`
        .row {
          display: flex;
        }
        .column {
          display: flex;
          flex-basis: 0;
          flex-direction: column;
          flex-grow: 1;
        }
        .column :global(.textarea-container) {
          height: 100%;
        }
        .column + .column {
          margin-left: 1.25rem;
        }
      `}</style>
    </div>
  );
};

export default EditTaskTemplate;

export const Route = createFileRoute('/_authenticated/settings/task/$id')({ component: EditTaskTemplate })
